import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useRoute, useRouteData } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import Classes, { UserAccount } from "model";
import { SVGAsset } from "res";

import "./styles.css";

export default function ManageRecipientsContent(props) {
    const { verified = false } = useRouteData().route ?? {};
    const context = useBCMSContext();
    const navigate = useRoute();

    BCMSRecord.globalControllerFor(Classes, context);

    const { phones, emails } = UserAccount.initAll().reduce((result, account) => {
        const onClick = evt => navigate(`/advancedAlerts/manageRecipient/${ account.id }`);

        if (account.id !== "0") {
            result.phones.push(<DisabledRecipientItem key={ `Recipient_Phone_${ account.id }`} account={ account } accountProp="workPhoneNumber" />);
            result.emails.push(<DisabledRecipientItem key={ `Recipient_Email_${ account.id }`} account={ account } accountProp="emailAddress" />);

            return result;
        }

        result.phones.push(<DisabledRecipientItem key={ `Recipient_Phone_${ account.id }`} account={ account } accountProp="workPhoneNumber" />);
        result.emails.push(<RecipientItem key={ `Recipient_Email_${ account.id }`} account={ account } accountProp="emailAddress" onClick={ onClick } />);

        return result;
    }, { phones: [], emails: [] });

    const onAddPhone = evt => navigate("/advancedAlerts/addPhoneWorkflow");
    const onAddEmail = evt => navigate("/advancedAlerts/addEmailWorkflow");

    return (
        <div className="manage-recipients-content back-link-padding">
            <Link to="/advancedAlerts" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Manage Recipients</p>

            { verified && 
                <div className="confirmation-banner flex-container flex-horizontal">
                    <SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />
                    <div className="flex-width confirm-text">The recipient was successfully verified.</div>
                </div> }

            <FormContainer className="small-form-width">
                <FormButtonRow>
                    <UIButton className="primary-button" text="Add Phone" onClick={ onAddPhone } />
                    <UIButton className="primary-button" text="Add Email" onClick={ onAddEmail } />
                </FormButtonRow>

                <FormRowView>
                    <div className="flex-container flex-vertical recipient-container">
                        { emails }
                        { phones }
                    </div>
                </FormRowView>
            </FormContainer>
        </div>
    );
}

function RecipientItem(props) {
    const account = props.account ?? UserAccount.firstInstanceOf();
    const accountProp = props.accountProp ?? "emailAddress";

    const onClick = props.onClick ?? undefined;
    const value = account[ accountProp ];

    const displayValue = accountProp === "workPhoneNumber"
        ? `(${ value.slice(0, 3) }) ${ value.slice (3, 6) }-${ value.slice(6) }`
        : value;

    return (
        <div className="flex-container flex-horizontal clickable recipient" onClick={ onClick }>
            <p className="flex-width">{ displayValue }</p>
            <SVGAsset id="RightChevronIcon" className="set-width" />
        </div>
    );
}

function DisabledRecipientItem(props) {
    return (
        <DisabledPrompt>
            <RecipientItem { ...props } />
        </DisabledPrompt>
    );
}